import { render, staticRenderFns } from "./WorkLevel.vue?vue&type=template&id=bafc471e&scoped=true&"
import script from "./WorkLevel.vue?vue&type=script&lang=js&"
export * from "./WorkLevel.vue?vue&type=script&lang=js&"
import style0 from "./WorkLevel.vue?vue&type=style&index=0&id=bafc471e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafc471e",
  null
  
)

export default component.exports